import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import futbolistaService from '../services/futbolistaService';
import { useAuth } from '../context/AuthContext';
import useWindowSize from '../hooks/useWindowSize';
import '../styles/home.css';
import '../styles/matches.css';

const HERO_IMAGES = [
  '/img/landing/hero_slide1.webp',
  '/img/landing/hero_slide2.webp',
  '/img/landing/hero_slide3.webp',
];

const LigaProkids = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { isMobile } = useWindowSize();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    const checkUserRedirection = async () => {
      if (user && user.role === 'parent') {
        try {
          const futbolistas = await futbolistaService.getFutbolistas();
          if (futbolistas && futbolistas.length > 0) {
            navigate('/tutor', { replace: true });
          }
        } catch (error) {
          console.error('Error al verificar futbolistas para redirección:', error);
        }
      }
    };
    checkUserRedirection();
  }, [user, navigate]);

  // Slideshow automático
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % HERO_IMAGES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const ctaBtn = {
    display: 'inline-block',
    padding: isMobile ? '10px 28px' : '11px 36px',
    backgroundColor: '#E3FF38',
    color: '#000000',
    borderRadius: '50px',
    fontWeight: 'bold',
    fontSize: isMobile ? '18px' : '25px',
    fontFamily: '"Poppins", sans-serif',
    textDecoration: 'none',
    border: '5px solid #E3FF38',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '0px',
    wordSpacing: '4px',
    cursor: 'pointer',
    textAlign: 'center',
    boxShadow: '0px 0px 10px 0px #000000',
    lineHeight: '1.3em',
  };

  const ctaBtnContent = <>
    <span>INSCRIBIRME</span>
    <span style={{
      display: 'block',
      fontSize: isMobile ? '10px' : '12px',
      fontWeight: '500',
      marginTop: '6px',
      letterSpacing: '0.5px',
      textTransform: 'none',
      opacity: 0.85,
    }}>
      1. Regístrate → 2. Crea tu futbolista → 3. Compra jornadas
    </span>
  </>;

  return (
    <>
      {/* ============ HERO CON SLIDESHOW ============ */}
      <section style={{
        position: 'relative',
        minHeight: isMobile ? '60vh' : '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}>
        {/* Slideshow de fondo */}
        {HERO_IMAGES.map((img, i) => (
          <div key={i} style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${img})`,
            backgroundSize: 'cover', backgroundPosition: 'center',
            opacity: currentSlide === i ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            zIndex: 0,
          }} />
        ))}
        {/* Overlay negro 50% */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 1,
        }} />

        {/* Contenido hero */}
        <div style={{
          position: 'relative', zIndex: 2,
          display: 'flex', flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'center' : 'flex-start', gap: isMobile ? '20px' : '40px',
          color: '#fff',
          padding: isMobile ? '0 15px' : '0 40px',
          maxWidth: '1100px', width: '100%',
          boxSizing: 'border-box',
        }}>
          {/* Logo a la izquierda */}
          <img src="/img/logos/liga-prokids-logo.png" alt="Liga ProKids"
            style={{
              width: isMobile ? '150px' : '220px',
              flexShrink: 0,
              filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.4))',
              marginTop: isMobile ? '0' : '5px',
            }} />
          {/* Texto a la derecha */}
          <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
            <p style={{
              fontSize: isMobile ? '14px' : '25px',
              fontWeight: '500', marginBottom: '30px',
              fontFamily: '"Poppins", sans-serif',
              textTransform: 'uppercase',
              lineHeight: isMobile ? '28px' : '42px',
              letterSpacing: isMobile ? '0.5px' : '1.5px',
              color: '#FFFFFF',
            }}>
              M&Aacute;S PARTIDOS. M&Aacute;S MINUTOS. M&Aacute;S OPORTUNIDADES.
            </p>
            <div style={{
              marginBottom: '20px',
              textAlign: 'left',
              fontFamily: '"Poppins", sans-serif',
              color: '#FFFFFF',
            }}>
              <p style={{
                margin: '0 0 10px 0',
                fontSize: isMobile ? '11px' : '15px',
                fontWeight: '500',
                lineHeight: isMobile ? '24px' : '28px',
                letterSpacing: isMobile ? '0.3px' : '0.5px',
              }}>
                Partidos de f&uacute;tbol organizados por edad y nivel, donde cada futbolista se inscribe individualmente y elige cu&aacute;ndo quiere jugar.
              </p>
              <p style={{
                margin: '0 0 8px 0',
                fontSize: isMobile ? '11px' : '15px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: isMobile ? '0.5px' : '1.5px',
                lineHeight: isMobile ? '24px' : '42px',
              }}>
                +40 MINUTOS GARANTIZADOS &middot; TOTAL FLEXIBILIDAD
              </p>
              <p style={{
                margin: '0 0 4px 0',
                fontSize: isMobile ? '11px' : '15px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: isMobile ? '0.5px' : '1.5px',
                lineHeight: isMobile ? '24px' : '42px',
              }}>
                Para futbolistas nacidos entre 2015 y 2022
              </p>
              <p style={{
                margin: '0',
                fontSize: isMobile ? '11px' : '15px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: isMobile ? '0.5px' : '1.5px',
                lineHeight: isMobile ? '24px' : '42px',
              }}>
                DESDE 16 &euro; POR PARTIDO
              </p>
            </div>
            <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
              <Link to="/register" style={ctaBtn}>{ctaBtnContent}</Link>
              <div style={{ marginTop: '14px', textAlign: 'center' }}>
                <a
                  href="#sedes"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById('sedes');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  style={{
                    display: 'inline-block',
                    fontFamily: '"Poppins", sans-serif',
                    fontSize: isMobile ? '11px' : '14px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: isMobile ? '0.5px' : '1.5px',
                    color: '#E3FF38',
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                >
                  VER SEDES, D&Iacute;AS Y HORARIOS &darr;
                </a>
                <p style={{
                  margin: '4px 0 0 0',
                  fontFamily: '"Poppins", sans-serif',
                  fontSize: isMobile ? '11px' : '13px',
                  fontWeight: '400',
                  color: '#FFFFFF',
                  opacity: 0.85,
                  letterSpacing: '0.3px',
                }}>
                  Vega Baja
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ ¿Y SI TU HIJO/A PUDIERA JUGAR OTRO PARTIDO? ============ */}
      <section style={{
        backgroundColor: '#FFFFFF',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{
          maxWidth: '1100px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          gap: isMobile ? '36px' : '60px',
        }}>
          {/* Texto izquierda */}
          <div style={{ flex: '1 1 45%' }}>
            <h2 style={{
              fontFamily: '"Bebas Neue", sans-serif',
              fontSize: isMobile ? '38px' : '58px',
              lineHeight: isMobile ? '42px' : '62px',
              color: '#00446D',
              margin: 0,
              textTransform: 'uppercase',
            }}>
              &iquest;Y SI TU HIJO/A PUDIERA JUGAR OTRO PARTIDO?
            </h2>
          </div>

          {/* Foto derecha con etiquetas encima */}
          <div style={{ flex: '1 1 50%' }}>
            {/* Etiquetas justo encima de la foto */}
            <div style={{
              display: 'flex',
              gap: '10px',
              marginBottom: '10px',
            }}>
              <span style={{
                backgroundColor: '#E3FF38',
                color: '#000000',
                fontFamily: '"Poppins", sans-serif',
                fontSize: isMobile ? '11px' : '13px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                padding: '5px 14px',
                borderRadius: '2px',
              }}>
                +40 MINUTOS
              </span>
              <span style={{
                backgroundColor: '#00446D',
                color: '#FFFFFF',
                fontFamily: '"Poppins", sans-serif',
                fontSize: isMobile ? '11px' : '13px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                padding: '5px 14px',
                borderRadius: '2px',
              }}>
                EDAD + NIVEL
              </span>
            </div>
            <img
              src="/img/landing/YDRAY-DSC_0796.JPG"
              alt="Partido Liga ProKids"
              style={{
                width: '100%',
                height: isMobile ? '260px' : '380px',
                objectFit: 'cover',
                display: 'block',
                borderRadius: '4px',
              }}
            />
          </div>
        </div>
      </section>

      {/* ============ ¿CÓMO FUNCIONA LIGA PROKIDS? ============ */}
      <section id="que-es" style={{
        padding: isMobile ? '50px 20px' : '80px 40px',
        backgroundColor: '#59C48F',
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          {/* Cabecera */}
          <div style={{ marginBottom: isMobile ? '20px' : '24px' }}>
            <div style={{
              display: 'inline-block',
              backgroundColor: '#007A44', borderColor: '#007A44',
              borderStyle: 'solid', borderWidth: '5px',
              padding: '10px 20px', marginBottom: '12px',
              boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
            }}>
              <h2 style={{
                fontSize: isMobile ? '28px' : '46px',
                fontFamily: '"Bebas Neue", sans-serif',
                color: '#FFFFFF', margin: 0, letterSpacing: '1px',
              }}>&iquest;C&Oacute;MO FUNCIONA LIGA PROKIDS?</h2>
            </div>
            <p style={{
              fontFamily: '"Bebas Neue", sans-serif',
              fontSize: isMobile ? '28px' : '40px',
              color: '#00446D',
              margin: 0,
              letterSpacing: '1px',
            }}>MUY F&Aacute;CIL.</p>
          </div>

          {/* 4 tarjetas */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
            gap: isMobile ? '16px' : '20px',
          }}>
            {[
              {
                num: '1',
                title: 'INSCRIBES A TU FUTBOLISTA',
                desc: 'No necesitas traer un equipo. La inscripción es individual.',
              },
              {
                num: '2',
                title: 'NOSOTROS CREAMOS SU PARTIDO',
                desc: 'Organizamos a los futbolistas teniendo en cuenta edad y nivel para buscar partidos equilibrados y competitivos.',
              },
              {
                num: '3',
                title: 'VIENE A JUGAR',
                desc: 'Partidos organizados y dirigidos por entrenadores, donde todos los futbolistas tienen un mínimo de 40 minutos garantizados.',
              },
              {
                num: '4',
                title: 'TÚ DECIDES CUÁNDO REPETIR',
                desc: 'Una jornada o un pack. Sin cuotas mensuales ni obligación de jugar todas las semanas.',
              },
            ].map((step) => (
              <div key={step.num} style={{
                backgroundColor: '#FFFFFF',
                padding: isMobile ? '20px' : '24px 28px',
                borderStyle: 'solid', borderWidth: '0 0 0 10px', borderColor: '#007A44',
                borderRadius: '20px', boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
                display: 'flex', flexDirection: 'column', gap: '10px',
              }}>
                <span style={{
                  fontFamily: '"Bebas Neue", sans-serif',
                  fontSize: isMobile ? '48px' : '60px',
                  lineHeight: '1',
                  color: '#007A44',
                  flexShrink: 0,
                }}>{step.num}</span>
                <div>
                  <p style={{
                    fontFamily: '"Poppins", sans-serif',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    color: '#00446D',
                    margin: '0 0 6px 0',
                  }}>{step.title}</p>
                  <p style={{
                    fontFamily: '"Poppins", sans-serif',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: '400',
                    lineHeight: '1.5',
                    color: '#333333',
                    margin: 0,
                  }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ NO JUNTAMOS JUGADORES. CREAMOS PARTIDOS. ============ */}
      <section style={{
        backgroundColor: '#00446D',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: isMobile ? '28px' : '36px',
        }}>
          {/* Título */}
          <h2 style={{
            fontFamily: '"Bebas Neue", sans-serif',
            fontSize: isMobile ? '34px' : '54px',
            lineHeight: isMobile ? '38px' : '58px',
            color: '#E3FF38',
            margin: 0,
            letterSpacing: '1px',
          }}>
            NO JUNTAMOS JUGADORES. CREAMOS PARTIDOS.
          </h2>

          {/* Descripción */}
          <p style={{
            fontFamily: '"Poppins", sans-serif',
            fontSize: isMobile ? '15px' : '18px',
            fontWeight: '400',
            lineHeight: '1.6',
            color: '#FFFFFF',
            margin: 0,
            maxWidth: '700px',
            textAlign: 'left',
            alignSelf: 'flex-start',
          }}>
            Cada jornada re&uacute;ne futbolistas de diferentes clubes para vivir algo diferente a su competici&oacute;n habitual, para jugar un nuevo partido = nuevos compa&ntilde;eros, nuevos rivales, nuevos retos.
          </p>

          {/* Vídeo */}
          <div style={{
            width: '100%',
            maxWidth: '700px',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          }}>
            <video
              src="/img/landing/YDRAY-LANDING-COMPRESSED.mp4"
              autoPlay
              muted
              loop
              playsInline
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </div>

          {/* CTA */}
          <Link to="/register" style={ctaBtn}>{ctaBtnContent}</Link>
        </div>
      </section>

      {/* ============ SEDES, HORARIOS Y CATEGORÍAS ============ */}
      <section id="sedes" style={{
        backgroundColor: '#F5F7FA',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          {/* Cabecera */}
          <div style={{
            display: 'inline-block',
            backgroundColor: '#007A44', borderColor: '#007A44',
            borderStyle: 'solid', borderWidth: '5px',
            padding: '10px 20px', marginBottom: '36px',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
          }}>
            <h2 style={{
              fontSize: isMobile ? '26px' : '44px',
              fontFamily: '"Bebas Neue", sans-serif',
              color: '#FFFFFF', margin: 0, letterSpacing: '1px',
            }}>SEDES, HORARIOS Y CATEGOR&Iacute;AS</h2>
          </div>

          {/* Sede */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            {[
              {
                city: 'ALGORFA',
                color: '#3EC1D3',
                locations: [
                  'Polideportivo Juan Carlos I (Querubín · Prebenjamín · Benjamín · Alevín)',
                ],
                years: '2022 – 2015',
                day: 'DOMINGO',
                slots: ['10:30 – 12:00', '12:00 – 13:30'],
              },
            ].map((sede) => (
              <div key={sede.city} style={{
                backgroundColor: '#FFFFFF',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                width: '100%',
                maxWidth: '480px',
              }}>
                {/* Cabecera de tarjeta */}
                <div style={{
                  backgroundColor: sede.color,
                  padding: '18px 22px',
                }}>
                  <h3 style={{
                    fontFamily: '"Bebas Neue", sans-serif',
                    fontSize: isMobile ? '32px' : '38px',
                    color: '#FFFFFF',
                    margin: 0,
                    letterSpacing: '2px',
                  }}>{sede.city}</h3>
                </div>

                {/* Cuerpo */}
                <div style={{ padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  {/* Instalaciones */}
                  <div>
                    {sede.locations.map((loc, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', margin: i === 0 ? '0 0 6px 0' : '0' }}>
                        <i className="fa-solid fa-location-dot" style={{ color: sede.color, fontSize: '13px', marginTop: '2px', flexShrink: 0 }}></i>
                        <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '13px' : '14px', color: '#333333', margin: 0, lineHeight: '1.4' }}>{loc}</p>
                      </div>
                    ))}
                  </div>

                  <hr style={{ border: 'none', height: '1px', backgroundColor: '#E0E0E0', margin: 0 }} />

                  {/* Años */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="fa-solid fa-cake-candles" style={{ fontSize: '16px', color: sede.color, flexShrink: 0, width: '18px', textAlign: 'center' }}></i>
                    <div>
                      <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#888', margin: '0 0 2px 0' }}>Años</p>
                      <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '15px', fontWeight: '600', color: '#00446D', margin: 0 }}>{sede.years}</p>
                    </div>
                  </div>

                  {/* Día */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="fa-solid fa-calendar-days" style={{ fontSize: '16px', color: sede.color, flexShrink: 0, width: '18px', textAlign: 'center' }}></i>
                    <div>
                      <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#888', margin: '0 0 2px 0' }}>Día de partido</p>
                      <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '17px' : '19px', color: sede.color, margin: 0, letterSpacing: '1px' }}>{sede.day}</p>
                    </div>
                  </div>

                  {/* Franjas */}
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <i className="fa-solid fa-clock" style={{ fontSize: '16px', color: sede.color, flexShrink: 0, width: '18px', textAlign: 'center', marginTop: '2px' }}></i>
                    <div>
                      <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#888', margin: '0 0 6px 0' }}>Franjas horarias</p>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {sede.slots.map((slot, i) => (
                          <span key={i} style={{
                            display: 'inline-block',
                            backgroundColor: sede.color,
                            color: '#FFFFFF',
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: '13px',
                            fontWeight: '600',
                            padding: '3px 10px',
                            borderRadius: '4px',
                            letterSpacing: '0.5px',
                          }}>{slot}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* ¿Cuándo sabré el horario? */}
          <div style={{
            marginTop: isMobile ? '36px' : '48px',
            backgroundColor: '#00446D',
            borderRadius: '12px',
            padding: isMobile ? '24px 20px' : '32px 36px',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            gap: isMobile ? '16px' : '32px',
          }}>
            <span style={{ fontSize: isMobile ? '36px' : '48px', flexShrink: 0 }}>📬</span>
            <div>
              <h3 style={{
                fontFamily: '"Bebas Neue", sans-serif',
                fontSize: isMobile ? '24px' : '32px',
                color: '#E3FF38',
                margin: '0 0 10px 0',
                letterSpacing: '1px',
              }}>
                &iquest;CU&Aacute;NDO SABR&Eacute; EL HORARIO?
              </h3>
              <p style={{
                fontFamily: '"Poppins", sans-serif',
                fontSize: isMobile ? '14px' : '15px',
                color: '#FFFFFF',
                margin: '0 0 6px 0',
                lineHeight: '1.6',
              }}>
                Las inscripciones de cada jornada cierran el <strong>jueves a las 23:59 h.</strong>
              </p>
              <p style={{
                fontFamily: '"Poppins", sans-serif',
                fontSize: isMobile ? '14px' : '15px',
                color: '#FFFFFF',
                margin: '0 0 6px 0',
                lineHeight: '1.6',
              }}>
                El <strong>viernes</strong> recibir&aacute;s el horario definitivo por <strong>email</strong> y en las <strong>notificaciones de tu perfil.</strong>
              </p>
              <p style={{
                fontFamily: '"Poppins", sans-serif',
                fontSize: isMobile ? '14px' : '15px',
                color: 'rgba(255,255,255,0.8)',
                margin: 0,
                lineHeight: '1.6',
                fontStyle: 'italic',
              }}>
                Tu partido ser&aacute; siempre dentro de una de las franjas indicadas para tu sede y categor&iacute;a.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ PRECIOS ============ */}
      <section style={{
        backgroundColor: '#00446D',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          {/* Cabecera */}
          <div style={{
            display: 'inline-block',
            backgroundColor: '#E3FF38',
            borderStyle: 'solid', borderWidth: '5px', borderColor: '#E3FF38',
            padding: '10px 20px', marginBottom: '48px',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.4)',
          }}>
            <h2 style={{
              fontSize: isMobile ? '26px' : '44px',
              fontFamily: '"Bebas Neue", sans-serif',
              color: '#00446D', margin: 0, letterSpacing: '1px',
            }}>PRECIOS &mdash; PAQUETES DISPONIBLES</h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: isMobile ? '24px' : '32px',
            alignItems: 'stretch',
          }}>
            {/* ── Columna izq: Primera experiencia ── */}
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <div style={{ backgroundColor: '#007A44', padding: '18px 24px' }}>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '11px' : '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '2px', color: '#E3FF38', margin: '0 0 4px 0' }}>
                  &iquest;ES VUESTRA PRIMERA VEZ?
                </p>
                <h3 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '28px' : '36px', color: '#FFFFFF', margin: 0, letterSpacing: '1px' }}>
                  PRIMERO JUEGA. DESPU&Eacute;S DECIDE.
                </h3>
              </div>
              <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '16px' }}>
                  <span style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '48px' : '58px', color: '#007A44', lineHeight: 1 }}>20 &euro;</span>
                  <span style={{ fontFamily: '"Poppins", sans-serif', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', color: '#555' }}>PRIMERA EXPERIENCIA</span>
                </div>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '15px', color: '#333', lineHeight: '1.6', margin: '0 0 8px 0' }}>
                  Vive una jornada completa sin tener que comprar todavía la equipación ProKids.
                </p>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '15px', color: '#333', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                  Nosotros te prestamos la equipación para disputar el partido.
                </p>
                <div style={{
                  backgroundColor: '#F0FFF6',
                  borderLeft: '4px solid #007A44',
                  borderRadius: '4px',
                  padding: '12px 16px',
                  marginBottom: '24px',
                }}>
                  <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '13px' : '14px', color: '#333', margin: '0 0 6px 0', lineHeight: '1.5' }}>
                    Y si después decide continuar:
                  </p>
                  <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '13px' : '14px', fontWeight: '700', color: '#007A44', margin: 0, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                    TE DESCONTAMOS 3 &euro; EN LA COMPRA DE SU EQUIPACI&Oacute;N.
                  </p>
                </div>
                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                  <Link to="/register" style={{ ...ctaBtn, fontSize: isMobile ? '14px' : '17px', padding: isMobile ? '10px 20px' : '12px 28px' }}>
                    QUIERO PROBAR LIGA PROKIDS
                  </Link>
                </div>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '12px' : '13px', color: '#888', margin: 0, textAlign: 'center', fontStyle: 'italic', lineHeight: '1.5' }}>
                  Una forma sencilla de conocer Liga ProKids antes de comprar su equipación.
                </p>
              </div>
            </div>

            {/* ── Columna der: Packs ── */}
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <div style={{ backgroundColor: '#00446D', padding: '18px 24px' }}>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '11px' : '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '2px', color: '#E3FF38', margin: '0 0 4px 0' }}>
                  &iquest;YA CONOCES LIGA PROKIDS?
                </p>
                <h3 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '28px' : '36px', color: '#FFFFFF', margin: 0, letterSpacing: '1px' }}>
                  ELIGE C&Oacute;MO QUIERES JUGAR
                </h3>
              </div>
              <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '12px', flex: 1 }}>
                {[
                  { label: 'JORNADA', price: '17 €', sub: null, highlight: false },
                  { label: 'PACK 4', price: '66 €', sub: '16,50 €/partido', highlight: false },
                  { label: 'PACK 8', price: '128 €', sub: '16 €/partido', highlight: true },
                ].map((pack) => (
                  <div key={pack.label} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    backgroundColor: pack.highlight ? '#00446D' : '#F5F7FA',
                    borderRadius: '8px',
                    padding: '14px 18px',
                  }}>
                    <div>
                      <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '20px' : '24px', color: pack.highlight ? '#E3FF38' : '#00446D', margin: 0, letterSpacing: '1px' }}>{pack.label}</p>
                      {pack.sub && <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: '12px', color: pack.highlight ? 'rgba(255,255,255,0.7)' : '#888', margin: 0 }}>{pack.sub}</p>}
                    </div>
                    <span style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '28px' : '34px', color: pack.highlight ? '#FFFFFF' : '#333', letterSpacing: '1px' }}>{pack.price}</span>
                  </div>
                ))}

                <hr style={{ border: 'none', height: '1px', backgroundColor: '#E0E0E0', margin: '4px 0' }} />

                {/* Equipación */}
                <div style={{
                  backgroundColor: '#FFF8E1',
                  border: '1px solid #FFD54F',
                  borderRadius: '8px',
                  padding: '14px 18px',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                    <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '18px' : '22px', color: '#00446D', margin: 0, letterSpacing: '1px' }}>
                      ⚽ EQUIPACI&Oacute;N OFICIAL
                    </p>
                    <span style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '22px' : '28px', color: '#333' }}>25 &euro;</span>
                  </div>
                  <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '12px' : '13px', color: '#555', margin: '0 0 4px 0', lineHeight: '1.5' }}>
                    Se a&ntilde;ade en la primera compra si todavía no dispones de ella.
                  </p>
                  <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '12px' : '13px', color: '#555', margin: 0, lineHeight: '1.5', fontStyle: 'italic' }}>
                    Si vienes de la Primera Experiencia, descontamos los 3 &euro; correspondientes al adquirir tu equipación.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ ORGANIZACIÓN Y TRANQUILIDAD ============ */}
      <section style={{
        backgroundColor: '#FFFFFF',
        padding: isMobile ? '36px 20px' : '52px 40px',
        borderTop: '1px solid #E8E8E8',
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          {/* Cabecera compacta */}
          <h2 style={{
            fontFamily: '"Bebas Neue", sans-serif',
            fontSize: isMobile ? '26px' : '38px',
            color: '#007A44', margin: '0 0 4px 0', letterSpacing: '1px',
          }}>
            ORGANIZACI&Oacute;N Y TRANQUILIDAD
          </h2>
          <h2 style={{
            fontFamily: '"Bebas Neue", sans-serif',
            fontSize: isMobile ? '26px' : '38px',
            color: '#00446D', margin: '0 0 28px 0', letterSpacing: '1px',
          }}>
            UN PARTIDO ORGANIZADO DE PRINCIPIO A FIN.
          </h2>

          {/* 4 iconos en fila */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
            gap: isMobile ? '20px' : '24px',
          }}>
            {[
              { icon: 'fa-solid fa-chalkboard-user', title: 'ENTRENADORES', desc: 'Entrenadores de primer nivel presentes durante la experiencia para organizar y dirigir los partidos.' },
              { icon: 'fa-solid fa-stopwatch', title: '+40 MINUTOS', desc: 'Todos los futbolistas vienen a jugar y tienen un mínimo de 40 minutos garantizados.' },
              { icon: 'fa-solid fa-shield-halved', title: 'COBERTURA', desc: 'La actividad cuenta con seguro de Responsabilidad Civil de la organización.' },
              { icon: 'fa-solid fa-kit-medical', title: 'ACCIDENTES', desc: 'Posibilidad de disponer de seguro de accidentes para el participante.' },
            ].map((item) => (
              <div key={item.title} style={{
                display: 'flex', flexDirection: 'column', gap: '8px',
              }}>
                <i className={item.icon} style={{ fontSize: isMobile ? '28px' : '32px', color: '#007A44', lineHeight: 1 }}></i>
                <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '17px' : '20px', color: '#00446D', margin: 0, letterSpacing: '1px' }}>{item.title}</p>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '12px' : '13px', color: '#555', margin: 0, lineHeight: '1.5' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ CADA PARTIDO CUENTA — PROPOINTS ============ */}
      <section style={{
        backgroundColor: '#00446D',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{
          maxWidth: '1100px', margin: '0 auto',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          gap: isMobile ? '40px' : '64px',
        }}>
          {/* Texto izquierda */}
          <div style={{ flex: '1 1 50%' }}>
            <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '26px' : '38px', color: '#E3FF38', margin: '0 0 4px 0', letterSpacing: '1px' }}>
              CADA PARTIDO CUENTA
            </h2>
            <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '48px' : '72px', color: '#FFFFFF', margin: '0 0 16px 0', letterSpacing: '2px', lineHeight: 1 }}>
              PROPOINTS
            </h2>
            <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '15px' : '17px', color: 'rgba(255,255,255,0.85)', margin: '0 0 20px 0', lineHeight: '1.6' }}>
              La experiencia Liga ProKids contin&uacute;a despu&eacute;s del pitido final.
            </p>
            <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '20px' : '26px', color: '#E3FF38', margin: '0 0 20px 0', letterSpacing: '2px' }}>
              JUEGA &middot; COMPITE &middot; MEJORA &middot; SUMA
            </p>
            <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '16px', color: 'rgba(255,255,255,0.85)', margin: '0 0 10px 0', lineHeight: '1.7' }}>
              Cada jornada permite conseguir ProPoints, logros individuales, avanzar en los rankings y alcanzar nuevos niveles y recompensas.
            </p>
            <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '16px', color: 'rgba(255,255,255,0.7)', margin: '0 0 28px 0', lineHeight: '1.7', fontStyle: 'italic' }}>
              Una motivaci&oacute;n extra para seguir jugando, compitiendo y mejorando.
            </p>
            <Link
              to="/propoints"
              style={{
                display: 'inline-block',
                padding: isMobile ? '12px 24px' : '14px 32px',
                backgroundColor: '#E3FF38',
                color: '#000000',
                borderRadius: '50px',
                fontFamily: '"Poppins", sans-serif',
                fontWeight: '700',
                fontSize: isMobile ? '13px' : '15px',
                textDecoration: 'none',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
            >
              AVERIGUA TODO SOBRE NUESTRO SISTEMA PROPOINTS
            </Link>
          </div>

          {/* Captura perfil derecha */}
          <div style={{ flex: '1 1 45%', display: 'flex', justifyContent: 'center' }}>
            <img
              src="/img/landing/perfil-futbolista.png"
              alt="Perfil futbolista Liga ProKids — ProPoints, ranking y logros"
              style={{
                width: '100%',
                maxWidth: '380px',
                borderRadius: '16px',
                boxShadow: '0 16px 48px rgba(0,0,0,0.4)',
                display: 'block',
              }}
            />
          </div>
        </div>
      </section>

      {/* ============ LA COMUNIDAD PROKIDS ============ */}
      <section style={{
        backgroundColor: '#007A44',
        padding: isMobile ? '36px 20px' : '52px 40px',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '32px' : '52px', color: '#E3FF38', margin: '0 0 8px 0', letterSpacing: '2px' }}>
            LA COMUNIDAD PROKIDS
          </h2>
          <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '28px' : '46px', color: '#FFFFFF', margin: '0 0 12px 0', letterSpacing: '1px' }}>
            FUTBOLISTAS DE CLUBES DE TODA LA PROVINCIA
          </h2>
          <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '17px', color: 'rgba(255,255,255,0.85)', margin: '0 0 48px 0', lineHeight: '1.6' }}>
            Una comunidad que sigue creciendo jornada tras jornada.
          </p>

          {/* Stats */}
          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            gap: isMobile ? '32px' : '64px',
            marginBottom: '24px',
          }}>
            {[
              { num: '+1000', label: 'FUTBOLISTAS' },
              { num: '+200', label: 'PARTIDOS' },
            ].map((stat) => (
              <div key={stat.label}>
                <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '64px' : '88px', color: '#E3FF38', margin: 0, lineHeight: 1, letterSpacing: '2px' }}>{stat.num}</p>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '13px' : '15px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '3px', color: '#FFFFFF', margin: 0 }}>{stat.label}</p>
              </div>
            ))}
          </div>

          <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '20px' : '28px', color: 'rgba(255,255,255,0.7)', margin: 0, letterSpacing: '4px' }}>
            ALICANTE &middot; ELCHE &middot; VEGA BAJA
          </p>
        </div>
      </section>

      {/* ============ ¿NECESITAS AYUDA? ============ */}
      <section style={{
        backgroundColor: '#F5F7FA',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{
            display: 'inline-block',
            backgroundColor: '#007A44', borderColor: '#007A44',
            borderStyle: 'solid', borderWidth: '5px',
            padding: '10px 20px', marginBottom: '36px',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
          }}>
            <h2 style={{ fontSize: isMobile ? '26px' : '40px', fontFamily: '"Bebas Neue", sans-serif', color: '#FFFFFF', margin: 0 }}>
              &iquest;TIENES ALGUNA DUDA O NECESITAS AYUDA?
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: isMobile ? '20px' : '24px',
            textAlign: 'left',
          }}>
            {/* Contacto directo */}
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '28px 24px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
              borderLeft: '6px solid #007A44',
            }}>
              <h4 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: '24px', color: '#00446D', margin: '0 0 10px 0', letterSpacing: '1px' }}>CONTACTA CON NOSOTROS</h4>
              <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '15px', color: '#555', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                Si necesitas ayuda para inscribirte, contacta con nosotros y te ayudamos a reservar tu plaza.
              </p>
              <a href="https://wa.me/34604972879" target="_blank" rel="noreferrer" style={{
                display: 'inline-flex', alignItems: 'center', gap: '10px',
                backgroundColor: '#25D366', color: '#FFFFFF',
                fontFamily: '"Poppins", sans-serif', fontSize: '15px', fontWeight: '700',
                padding: '12px 24px', borderRadius: '50px', textDecoration: 'none',
                boxShadow: '0 4px 12px rgba(37,211,102,0.35)',
              }}>
                <i className="fa-brands fa-whatsapp" style={{ fontSize: '20px' }}></i>
                ENVIAR UN MENSAJE
              </a>
            </div>

            {/* Grupos por sede */}
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '28px 24px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
              borderLeft: '6px solid #00446D',
            }}>
              <h4 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: '24px', color: '#00446D', margin: '0 0 10px 0', letterSpacing: '1px' }}>GRUPOS DE WHATSAPP</h4>
              <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '15px', color: '#555', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                &Uacute;nete al grupo oficial de tu sede para estar al tanto de todas las novedades.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {[
                  { label: 'GRUPO SEDE ALGORFA', href: 'https://chat.whatsapp.com/Hbtc4naNG5dDny8qn116dW' },
                ].map((grupo) => (
                  <a key={grupo.label} href={grupo.href} target="_blank" rel="noreferrer" style={{
                    display: 'inline-flex', alignItems: 'center', gap: '10px',
                    backgroundColor: '#25D366', color: '#FFFFFF',
                    fontFamily: '"Poppins", sans-serif', fontSize: '14px', fontWeight: '700',
                    padding: '10px 20px', borderRadius: '50px', textDecoration: 'none',
                    boxShadow: '0 4px 12px rgba(37,211,102,0.25)',
                  }}>
                    <i className="fa-brands fa-whatsapp" style={{ fontSize: '18px' }}></i>
                    {grupo.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ FAQs ============ */}
      <section style={{
        backgroundColor: '#00446D',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Cabecera */}
          <div style={{ marginBottom: isMobile ? '28px' : '40px', textAlign: 'center' }}>
            <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '32px' : '52px', color: '#E3FF38', margin: '0 0 4px 0', letterSpacing: '1px' }}>
              PREGUNTAS FRECUENTES
            </h2>
          </div>

          {/* Acordeón */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {[
              { icon: 'fa-solid fa-futbol', q: '¿PUEDE JUGAR SI YA ESTÁ EN UN CLUB?', a: 'Sí. Liga ProKids complementa su fútbol habitual con nuevos partidos, compañeros, rivales y oportunidades para seguir mejorando.' },
              { icon: 'fa-solid fa-user-plus', q: '¿Y SI NO ESTÁ EN NINGÚN CLUB?', a: 'También puede participar. Buscaremos el partido más adecuado teniendo en cuenta su edad y nivel.' },
              { icon: 'fa-solid fa-ranking-star', q: '¿Y SI TIENE MUCHO NIVEL?', a: 'Tenemos en cuenta edad y nivel buscando partidos competitivos, equilibrados y que supongan un reto para los futbolistas.' },
              { icon: 'fa-solid fa-users', q: '¿TENGO QUE TRAER UN EQUIPO?', a: 'No. La inscripción es individual. Nosotros organizamos los equipos y el partido.' },
              { icon: 'fa-solid fa-chalkboard-user', q: '¿HAY ENTRENADORES?', a: 'Sí. Las jornadas cuentan con entrenadores que participan en la organización y dirección de la experiencia.' },
              { icon: 'fa-solid fa-calendar-check', q: '¿TIENE QUE JUGAR TODAS LAS SEMANAS?', a: 'No. Tú eliges cuándo participar.' },
              { icon: 'fa-solid fa-stopwatch', q: '¿CUÁNTO VA A JUGAR?', a: 'Un mínimo de 40 minutos. En Liga ProKids todos vienen a jugar.' },
              { icon: 'fa-solid fa-shirt', q: '¿NECESITA EQUIPACIÓN?', a: 'Sí, salvo en la Primera Experiencia, donde nosotros se la prestamos. La equipación oficial cuesta 25 €.' },
              { icon: 'fa-solid fa-shield-halved', q: '¿HAY SEGURO?', a: 'La organización dispone de seguro de Responsabilidad Civil. Además, existe la posibilidad de contratar/disponer de cobertura de accidentes para el participante.' },
            ].map((faq, i) => {
              const isOpen = openFaq === i;
              return (
                <div key={i} style={{
                  backgroundColor: isOpen ? '#FFFFFF' : 'rgba(255,255,255,0.07)',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  border: isOpen ? '2px solid #E3FF38' : '2px solid transparent',
                  transition: 'background-color 0.2s, border-color 0.2s',
                }}>
                  <button
                    onClick={() => setOpenFaq(isOpen ? null : i)}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: isMobile ? '14px 16px' : '16px 20px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      textAlign: 'left',
                    }}
                  >
                    <i className={faq.icon} style={{ fontSize: '18px', color: isOpen ? '#007A44' : '#E3FF38', flexShrink: 0, width: '20px', textAlign: 'center' }}></i>
                    <span style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '17px' : '20px', color: isOpen ? '#00446D' : '#FFFFFF', letterSpacing: '0.5px', flex: 1 }}>
                      {faq.q}
                    </span>
                    <i className={isOpen ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'} style={{ fontSize: '13px', color: isOpen ? '#007A44' : '#E3FF38', flexShrink: 0 }}></i>
                  </button>
                  {isOpen && (
                    <div style={{ padding: '0 20px 16px 54px' }}>
                      <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '15px', color: '#333', lineHeight: '1.6', margin: 0 }}>
                        {faq.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ============ LIGA PROKIDS ES PARA ÉL SI ============ */}
      <section style={{
        backgroundColor: '#59C48F',
        padding: isMobile ? '50px 20px' : '80px 40px',
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Título */}
          <div style={{
            display: 'inline-block',
            backgroundColor: '#007A44', borderColor: '#007A44',
            borderStyle: 'solid', borderWidth: '5px',
            padding: '10px 20px', marginBottom: '32px',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
          }}>
            <h2 style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '24px' : '40px', color: '#FFFFFF', margin: 0, letterSpacing: '1px' }}>
              LIGA PROKIDS ES PARA &Eacute;L SI...
            </h2>
          </div>

          {/* Lista de checkmarks */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '28px' }}>
            {[
              'Quiere jugar más partidos.',
              'Quiere enfrentarse a nuevos rivales.',
              'Quiere competir con futbolistas de otros clubes.',
              'Quiere seguir mejorando y poniéndose a prueba.',
              'Quiere disfrutar de más minutos sin miedo a equivocarse.',
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                <i className="fa-solid fa-circle-check" style={{ fontSize: isMobile ? '18px' : '22px', color: '#FFFFFF', flexShrink: 0, marginTop: '2px' }}></i>
                <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '15px' : '18px', fontWeight: '500', color: '#FFFFFF', margin: 0, lineHeight: '1.5' }}>{item}</p>
              </div>
            ))}
          </div>

          {/* O simplemente */}
          <div style={{
            backgroundColor: '#00446D',
            borderRadius: '12px',
            padding: isMobile ? '20px' : '28px 32px',
            marginBottom: '32px',
            textAlign: 'center',
          }}>
            <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '16px', color: 'rgba(255,255,255,0.8)', margin: '0 0 6px 0', letterSpacing: '1px', textTransform: 'uppercase' }}>
              O simplemente...
            </p>
            <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '32px' : '46px', color: '#E3FF38', margin: '0 0 20px 0', letterSpacing: '2px', lineHeight: 1 }}>
              LE ENCANTA JUGAR AL F&Uacute;TBOL.
            </p>
            <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '14px' : '16px', color: 'rgba(255,255,255,0.85)', margin: '0 0 16px 0', lineHeight: '1.6' }}>
              Da igual si juega habitualmente todos los minutos con su equipo o si est&aacute; buscando m&aacute;s oportunidades.
            </p>
            <p style={{ fontFamily: '"Bebas Neue", sans-serif', fontSize: isMobile ? '20px' : '28px', color: '#FFFFFF', margin: 0, letterSpacing: '1px' }}>
              SI QUIERE M&Aacute;S F&Uacute;TBOL, AQU&Iacute; TIENE OTRO PARTIDO.
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: 'center' }}>
            <Link to="/register" style={ctaBtn}>{ctaBtnContent}</Link>
            <p style={{ fontFamily: '"Poppins", sans-serif', fontSize: isMobile ? '12px' : '14px', color: '#FFFFFF', margin: '14px 0 0 0', opacity: 0.85, letterSpacing: '0.5px' }}>
              Desde 16 &euro;/partido &middot; +40 minutos &middot; Por edad y nivel
            </p>
          </div>
        </div>
      </section>

      {/* ============ PATROCINADORES ============ */}
      <section style={{
        padding: isMobile ? '50px 20px' : '70px 40px',
        backgroundColor: '#FFFFFF',
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{
            display: 'inline-block',
            backgroundColor: '#007A44', borderColor: '#007A44',
            borderStyle: 'solid', borderWidth: '5px',
            padding: '10px', marginBottom: '35px',
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
          }}>
            <h2 style={{
              fontSize: isMobile ? '35px' : '50px',
              fontFamily: '"Bebas Neue", sans-serif',
              color: '#FFFFFF', margin: 0,
            }}>NUESTROS PATROCINADORES</h2>
          </div>
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px',
          }}>
            <div style={{ display: 'flex', gap: '50px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
              <img src="/img/1x/logo_telfy.png" alt="Telfy" style={{ height: isMobile ? '60px' : '80px', objectFit: 'contain' }} />
            </div>
            <div style={{ display: 'flex', gap: '35px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
              {['WS.jpg', 'RB.jpg', 'brithol2.png', 'imporecord.png'].map(logo => (
                <img key={logo} src={`/img/1x/${logo}`} alt={logo.split('.')[0]}
                  style={{ height: isMobile ? '40px' : '50px', objectFit: 'contain', borderRadius: '4px' }} />
              ))}
            </div>
          </div>

        </div>
      </section>

    </>
  );
};

export default LigaProkids;
